module.exports = "<osr-disclaimer></osr-disclaimer>\r\n<microbiology [siteId]=\"siteId\" class=\"full-height-flex\"></microbiology>\r\n"